/**
 * @generated SignedSource<<d7225767ad837ebc7b24dec37a9479e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStepDetailsContainer_buyer$data = {
  readonly hasBankAccounts: boolean | null;
  readonly hasCreditCards: boolean | null;
  readonly hasShippingAddresses: boolean | null;
  readonly " $fragmentType": "CheckoutReviewStepDetailsContainer_buyer";
};
export type CheckoutReviewStepDetailsContainer_buyer$key = {
  readonly " $data"?: CheckoutReviewStepDetailsContainer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStepDetailsContainer_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStepDetailsContainer_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasShippingAddresses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCreditCards",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBankAccounts",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9119e56db6d00bca126f7bb1c06a7c6e";

export default node;
